import React from "react";
import { Navigate } from "react-router-dom";

//MS Graph imports
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../constants/authConfig";

//API Imports
import { loginOid, loginValidateToken } from "../../api/auth.js";
import { fetchTenantByUserId } from "../../api/tenant.js"

//Cookie imports
import Cookies from "universal-cookie";
import {
  COOKIE_AUTH_KEY,
} from "../../constants/constants.js";

// Logger
import { logger } from "../../api/logger";

import { detectDevice, DEVICE_TYPE } from "../../constants/detectDevice.js";

const Authorize = (props) => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [redirect, setRedirect] = React.useState(<div></div>);

  const requestProfileData = async () => {
    //Silent token check
    const response = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });

    const userToken = await loginOid(response.account.localAccountId);
    const cookies = new Cookies();

    if (userToken.isLoginSuccess === true) {
      const isMobile = detectDevice !== DEVICE_TYPE.PC;
      const options = { path: "/" };
      if (isMobile) {
        options["expires"] = new Date(Date.now() + 86400000);
      }
      cookies.set(COOKIE_AUTH_KEY, userToken.token, options);

      const userData = await loginValidateToken();

      userData.userData.user["companyIds"] = [];
      userData.userData.user["vesselIds"] = [];
      // role_id 0: admin, can access all vessels of the company
      // role_id 1: member, may access specific vessels of the company
      // role_id 2: 3rd party, may access specific vessels of the company
      // role_id 3: global admin (JRCS users), does not have tenant_id
      if (userData.userData.user.role_id != 3) {
        const tenant = await fetchTenantByUserId(userData.userData.user.id);
        const rbac = tenant.tenant.Tenant.rbac;
        if (userData.userData.user.role_id == 0) 
          userData.userData.user["companyIds"] = rbac.map(item => item.mgr).flat();
        else
          rbac.forEach(item => {
            if (item.rids.includes(userData.userData.user.role_id))
              userData.userData.user["vesselIds"] = userData.userData.user["vesselIds"].concat(item.vsl);
          });
      }
      else
        userData.userData.user["companyIds"] = [userData.userData.user.company_id];

      if (userData.isValid) {
        props.setUserContext(userData.userData);
        setRedirect(<Navigate to="/main" />);
      } else {
        logger.error("Invalid authentication.");
        alert("Invalid authentication");
        props.setUserContext(null); //Remove currently stored user context.
        setRedirect(<Navigate to="/" />);
      }
    } else {
      logger.error("No info on database.");
      alert("No info on database");
      props.setUserContext(null); //Remove currently stored user context
      setRedirect(<Navigate to="/" />);
    }
  };

  React.useEffect(() => {
    if (isAuthenticated) {
      logger.info("User is authenticated.");
      requestProfileData();
    }
  }, [isAuthenticated]);

  return redirect;
};

export default Authorize;
